import ScreenContainer from "../components/screen";
import { useLanguage } from "../config/language/LanguageContext";

export default function HelpCenter() {
  const { locale } = useLanguage();

  return (
    <ScreenContainer>
      <section id="faq" className="py-16 bg-white">
        <h2 className="text-3xl font-semibold text-gray-800 text-center mb-10">
          {locale.HELP_PAGE.title}
        </h2>
        <p className="text-center text-gray-600 text-base">
          {locale.HELP_PAGE.description}
          <a
            href="mailto:contact@myqrmenu.co"
            className="text-blue-600 underline"
          >
            {locale.HELP_PAGE.contactEmail}
          </a>
        </p>
        <p className="text-center text-gray-600 text-base">
          {locale.HELP_PAGE.faqPrompt}
        </p>

      </section>
    </ScreenContainer>
  )
}
